var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-custom-color-picker', _vm._g(_vm._b({ staticClass: "el-custom-color-picker", attrs: { "value": _vm.color }, on: { "change": _vm.handleChange } }, 'el-custom-color-picker', _vm.config.field, false), _vm.$listeners));
};
var staticRenderFns = [];

export { render, staticRenderFns };